webpackJsonp([1],{

/***/ "0pP6":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Calculator_vue__ = __webpack_require__("Lg5j");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_1fb31011_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Calculator_vue__ = __webpack_require__("fjlF");
function injectStyle (ssrContext) {
  __webpack_require__("SgyC")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
  var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Calculator_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_1fb31011_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Calculator_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "Du/2":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return APPEND_NUMBER; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return CLEAR; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return ADD; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "h", function() { return SUBTRACT; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "f", function() { return MULTIPLY; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "e", function() { return DIVIDE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return CALCULATE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "g", function() { return SET_OPERAND_VALUE; });
var APPEND_NUMBER = 'APPEND_NUMBER';
var CLEAR = 'CLEAR';
var ADD = 'ADD';
var SUBTRACT = 'SUBTRACT';
var MULTIPLY = 'MULTIPLY';
var DIVIDE = 'DIVIDE';
var CALCULATE = 'CALCULATE';
var SET_OPERAND_VALUE = 'SET_OPERAND_VALUE';

/***/ }),

/***/ "IcnI":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__("7+uW");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vuex__ = __webpack_require__("NYxO");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__mutations__ = __webpack_require__("ukYY");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__actions__ = __webpack_require__("mUbh");





__WEBPACK_IMPORTED_MODULE_0_vue__["default"].use(__WEBPACK_IMPORTED_MODULE_1_vuex__["a" /* default */]);

var state = {
    result: 0,
    visibleValue: 0,
    firstOperand: null,
    operator: null,
    secondOperand: null,
    append: true
};

/* harmony default export */ __webpack_exports__["a"] = (new __WEBPACK_IMPORTED_MODULE_1_vuex__["a" /* default */].Store({
    state: state,
    actions: __WEBPACK_IMPORTED_MODULE_3__actions__,
    mutations: __WEBPACK_IMPORTED_MODULE_2__mutations__["a" /* default */]
}));

/***/ }),

/***/ "Lg5j":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__("Dd8w");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__Operator__ = __webpack_require__("zeQx");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__Operand__ = __webpack_require__("d0Kl");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_vuex__ = __webpack_require__("NYxO");

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//





/* harmony default export */ __webpack_exports__["a"] = ({
    name: 'Calculator',
    components: {
        Operator: __WEBPACK_IMPORTED_MODULE_1__Operator__["a" /* default */],
        Operand: __WEBPACK_IMPORTED_MODULE_2__Operand__["a" /* default */]
    },
    computed: Object(__WEBPACK_IMPORTED_MODULE_3_vuex__["c" /* mapState */])(['visibleValue', 'result']),
    methods: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, Object(__WEBPACK_IMPORTED_MODULE_3_vuex__["b" /* mapActions */])(['clear', 'calculate']), {
        operate: function operate(action) {
            this.$store.dispatch(action);
        },
        onKeyup: function onKeyup(event) {
            var value = event.target.value;
            this.$store.dispatch('setOperandValue', value);
        }
    })

});

/***/ }),

/***/ "M93x":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_App_vue__ = __webpack_require__("xJD8");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_071786d7_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_App_vue__ = __webpack_require__("i7Kp");
function injectStyle (ssrContext) {
  __webpack_require__("zA8g")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
  var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_App_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_071786d7_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_App_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "NHnr":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__("7+uW");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__App__ = __webpack_require__("M93x");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_element_ui__ = __webpack_require__("zL8q");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_element_ui___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_element_ui__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_element_ui_lib_theme_chalk_index_css__ = __webpack_require__("tvR6");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_element_ui_lib_theme_chalk_index_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_element_ui_lib_theme_chalk_index_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_vuex__ = __webpack_require__("NYxO");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__store__ = __webpack_require__("IcnI");
// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.







__WEBPACK_IMPORTED_MODULE_0_vue__["default"].use(__WEBPACK_IMPORTED_MODULE_4_vuex__["a" /* default */]);
__WEBPACK_IMPORTED_MODULE_0_vue__["default"].use(__WEBPACK_IMPORTED_MODULE_2_element_ui___default.a);

__WEBPACK_IMPORTED_MODULE_0_vue__["default"].config.productionTip = false;

/* eslint-disable no-new */
new __WEBPACK_IMPORTED_MODULE_0_vue__["default"]({
  store: __WEBPACK_IMPORTED_MODULE_5__store__["a" /* default */],
  el: '#app',
  template: '<App/>',
  components: { App: __WEBPACK_IMPORTED_MODULE_1__App__["a" /* default */] }
});

/***/ }),

/***/ "SgyC":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "ZDkW":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('el-button',{nativeOn:{"click":function($event){_vm.appendNumber(_vm.value)}}},[_vm._v(_vm._s(_vm.value))])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "d0Kl":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Operand_vue__ = __webpack_require__("sA4L");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_430076ca_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Operand_vue__ = __webpack_require__("ZDkW");
var normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
  var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Operand_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_430076ca_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Operand_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "fjlF":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('el-row',{attrs:{"gutter":20}},[_c('el-col',{attrs:{"span":20}},[_vm._v("Result: "+_vm._s(_vm.result))]),_vm._v(" "),_c('el-col',{attrs:{"span":4}},[_c('el-button',{attrs:{"type":"warning"},nativeOn:{"click":function($event){_vm.calculate($event)}}},[_vm._v("=")])],1)],1),_vm._v(" "),_c('el-row',{attrs:{"gutter":20}},[_c('el-col',{attrs:{"span":20}},[_c('el-input',{attrs:{"value":_vm.visibleValue},nativeOn:{"keyup":function($event){_vm.onKeyup($event)}}})],1),_vm._v(" "),_c('el-col',{attrs:{"span":4}},[_c('el-button',{attrs:{"type":"danger"},nativeOn:{"click":function($event){_vm.clear($event)}}},[_vm._v("AC")])],1)],1),_vm._v(" "),_c('el-row',{attrs:{"gutter":10}},[_c('el-col',{attrs:{"span":6}},[_c('Operand',{attrs:{"value":"1"}})],1),_vm._v(" "),_c('el-col',{attrs:{"span":6}},[_c('Operand',{attrs:{"value":"2"}})],1),_vm._v(" "),_c('el-col',{attrs:{"span":6}},[_c('Operand',{attrs:{"value":"3"}})],1),_vm._v(" "),_c('el-col',{attrs:{"span":6}},[_c('Operator',{attrs:{"value":"+","action":"add"},on:{"operate":_vm.operate}})],1)],1),_vm._v(" "),_c('el-row',{attrs:{"gutter":10}},[_c('el-col',{attrs:{"span":6}},[_c('Operand',{attrs:{"value":"4"}})],1),_vm._v(" "),_c('el-col',{attrs:{"span":6}},[_c('Operand',{attrs:{"value":"5"}})],1),_vm._v(" "),_c('el-col',{attrs:{"span":6}},[_c('Operand',{attrs:{"value":"6"}})],1),_vm._v(" "),_c('el-col',{attrs:{"span":6}},[_c('Operator',{attrs:{"value":"-","action":"subtract"},on:{"operate":_vm.operate}})],1)],1),_vm._v(" "),_c('el-row',{attrs:{"gutter":10}},[_c('el-col',{attrs:{"span":6}},[_c('Operand',{attrs:{"value":"7"}})],1),_vm._v(" "),_c('el-col',{attrs:{"span":6}},[_c('Operand',{attrs:{"value":"8"}})],1),_vm._v(" "),_c('el-col',{attrs:{"span":6}},[_c('Operand',{attrs:{"value":"9"}})],1),_vm._v(" "),_c('el-col',{attrs:{"span":6}},[_c('Operator',{attrs:{"value":"X","action":"multiply"},on:{"operate":_vm.operate}})],1)],1),_vm._v(" "),_c('el-row',{attrs:{"gutter":10}},[_c('el-col',{attrs:{"span":6}},[_vm._v(" ")]),_vm._v(" "),_c('el-col',{attrs:{"span":6}},[_c('Operand',{attrs:{"value":"0"}})],1),_vm._v(" "),_c('el-col',{attrs:{"span":6}},[_vm._v(" ")]),_vm._v(" "),_c('el-col',{attrs:{"span":6}},[_c('Operator',{attrs:{"value":"/","action":"divide"},on:{"operate":_vm.operate}})],1)],1)],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "i7Kp":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"app"}},[_c('el-container',[_c('el-main',[_c('Calculator')],1)],1)],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "m18A":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('el-button',{attrs:{"type":"primary"},nativeOn:{"click":function($event){_vm.clicked($event)}}},[_vm._v(_vm._s(_vm.value))])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "mUbh":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "add", function() { return add; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "subtract", function() { return subtract; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "multiply", function() { return multiply; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "divide", function() { return divide; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "clear", function() { return clear; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "appendNumber", function() { return appendNumber; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "calculate", function() { return calculate; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "setOperandValue", function() { return setOperandValue; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__mutation_types__ = __webpack_require__("Du/2");


var add = function add(_ref) {
    var commit = _ref.commit;

    commit(__WEBPACK_IMPORTED_MODULE_0__mutation_types__["a" /* ADD */]);
};

var subtract = function subtract(_ref2) {
    var commit = _ref2.commit;

    commit(__WEBPACK_IMPORTED_MODULE_0__mutation_types__["h" /* SUBTRACT */]);
};

var multiply = function multiply(_ref3) {
    var commit = _ref3.commit;

    commit(__WEBPACK_IMPORTED_MODULE_0__mutation_types__["f" /* MULTIPLY */]);
};

var divide = function divide(_ref4) {
    var commit = _ref4.commit;

    commit(__WEBPACK_IMPORTED_MODULE_0__mutation_types__["e" /* DIVIDE */]);
};

var clear = function clear(_ref5) {
    var commit = _ref5.commit;

    commit(__WEBPACK_IMPORTED_MODULE_0__mutation_types__["d" /* CLEAR */]);
};

var appendNumber = function appendNumber(_ref6, value) {
    var commit = _ref6.commit;

    commit(__WEBPACK_IMPORTED_MODULE_0__mutation_types__["b" /* APPEND_NUMBER */], { value: value });
};

var calculate = function calculate(_ref7) {
    var commit = _ref7.commit;

    commit(__WEBPACK_IMPORTED_MODULE_0__mutation_types__["c" /* CALCULATE */]);
};

var setOperandValue = function setOperandValue(_ref8, value) {
    var commit = _ref8.commit;

    commit(__WEBPACK_IMPORTED_MODULE_0__mutation_types__["g" /* SET_OPERAND_VALUE */], { value: value });
};

/***/ }),

/***/ "pfUH":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
//
//
//
//

/* harmony default export */ __webpack_exports__["a"] = ({
    name: 'Operator',
    props: ['value', 'action'],
    methods: {
        clicked: function clicked() {
            this.$emit('operate', this.action);
        }
    }
});

/***/ }),

/***/ "sA4L":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vuex__ = __webpack_require__("NYxO");
//
//
//
//



/* harmony default export */ __webpack_exports__["a"] = ({
    name: 'Operand',
    props: ['value'],
    methods: Object(__WEBPACK_IMPORTED_MODULE_0_vuex__["b" /* mapActions */])(['appendNumber'])
});

/***/ }),

/***/ "tvR6":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "ukYY":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty__ = __webpack_require__("bOdI");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__mutation_types__ = __webpack_require__("Du/2");


var _types$APPEND_NUMBER$;



/* harmony default export */ __webpack_exports__["a"] = (_types$APPEND_NUMBER$ = {}, __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_types$APPEND_NUMBER$, __WEBPACK_IMPORTED_MODULE_1__mutation_types__["b" /* APPEND_NUMBER */], function (state, _ref) {
    var value = _ref.value;

    if (state.append) {
        state.visibleValue = parseFloat(state.visibleValue.toString() + value.toString());
    } else {
        state.visibleValue = parseFloat(value);
        state.append = true;
    }
    if (state.operator) {
        state.secondOperand = state.visibleValue;
    } else {
        state.firstOperand = state.visibleValue;
    }
}), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_types$APPEND_NUMBER$, __WEBPACK_IMPORTED_MODULE_1__mutation_types__["a" /* ADD */], function (state) {
    state.append = false;
    if (state.operator) {
        calculate(state);
        state.operator = 'ADD';
        return;
    }
    state.operator = 'ADD';

    if (state.firstOperand && state.secondOperand) {
        state.result = state.firstOperand + state.secondOperand;
        state.firstOperand = state.result;
        state.secondOperand = null;
    }
}), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_types$APPEND_NUMBER$, __WEBPACK_IMPORTED_MODULE_1__mutation_types__["h" /* SUBTRACT */], function (state) {
    state.append = false;
    if (state.operator) {
        calculate(state);
        state.operator = 'SUBTRACT';
        return;
    }
    state.operator = 'SUBTRACT';

    if (state.firstOperand && state.secondOperand) {
        state.result = state.firstOperand - state.secondOperand;
        state.firstOperand = state.result;
        state.secondOperand = null;
    }
}), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_types$APPEND_NUMBER$, __WEBPACK_IMPORTED_MODULE_1__mutation_types__["e" /* DIVIDE */], function (state) {
    state.append = false;
    if (state.operator) {
        calculate(state);
        state.operator = 'DIVIDE';
        return;
    }
    state.operator = 'DIVIDE';

    if (state.firstOperand && state.secondOperand) {
        state.result = state.firstOperand / state.secondOperand;
        state.firstOperand = state.result;
        state.secondOperand = null;
    }
}), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_types$APPEND_NUMBER$, __WEBPACK_IMPORTED_MODULE_1__mutation_types__["f" /* MULTIPLY */], function (state) {
    state.append = false;
    if (state.operator) {
        calculate(state);
        state.operator = 'MULTIPLY';
        return;
    }
    state.operator = 'MULTIPLY';

    if (state.firstOperand && state.secondOperand) {
        state.result = state.firstOperand * state.secondOperand;
        state.firstOperand = state.result;
        state.secondOperand = null;
    }
}), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_types$APPEND_NUMBER$, __WEBPACK_IMPORTED_MODULE_1__mutation_types__["c" /* CALCULATE */], function (state) {
    state.append = false;
    calculate(state);
    state.visibleValue = state.result;
    state.operator = null;
}), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_types$APPEND_NUMBER$, __WEBPACK_IMPORTED_MODULE_1__mutation_types__["d" /* CLEAR */], function (state) {
    state.result = 0;
    state.visibleValue = 0;
    state.firstOperand = null;
    state.secondOperand = null;
    state.operator = null;
}), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_types$APPEND_NUMBER$, __WEBPACK_IMPORTED_MODULE_1__mutation_types__["g" /* SET_OPERAND_VALUE */], function (state, _ref2) {
    var value = _ref2.value;

    if (state.operator) {
        state.secondOperand = parseFloat(value);
    } else {
        state.firstOperand = parseFloat(value);
    }
    state.visibleValue = parseFloat(value);
}), _types$APPEND_NUMBER$);

function calculate(state) {
    if (!state.firstOperand || !state.secondOperand || !state.operator) {
        return;
    }
    if (state.operator === 'ADD') {
        state.result = state.firstOperand + state.secondOperand;
    } else if (state.operator === 'SUBTRACT') {
        state.result = state.firstOperand - state.secondOperand;
    } else if (state.operator === 'MULTIPLY') {
        state.result = state.firstOperand * state.secondOperand;
    } else if (state.operator === 'DIVIDE') {
        state.result = state.firstOperand / state.secondOperand;
    }
    state.firstOperand = state.result;
    state.secondOperand = null;
}

/***/ }),

/***/ "xJD8":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_Calculator__ = __webpack_require__("0pP6");
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'app',
  components: {
    Calculator: __WEBPACK_IMPORTED_MODULE_0__components_Calculator__["a" /* default */]
  }
});

/***/ }),

/***/ "zA8g":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "zeQx":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Operator_vue__ = __webpack_require__("pfUH");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_70d69e73_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Operator_vue__ = __webpack_require__("m18A");
var normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
  var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Operator_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_70d69e73_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Operator_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ })

},["NHnr"]);


// WEBPACK FOOTER //
// static/js/app.775cf1734248c4aa39d1.js